const SET_FILE = (state, data) => {
  state.file = data
}

const UNSET_FILE = (state) => {
  state.file = null
}

const SET_PROGRESS = (state, progress) => {
  state.progress = progress
}

export default {
  SET_FILE,
  UNSET_FILE,
  SET_PROGRESS
}
